module.exports = __webpack_public_path__ + "img/coverImg.00a1cfb2.png";